export default {
    "graphqlEndpoint": "https://icemqn5opzewdeer2s2isyg5su.appsync-api.us-east-1.amazonaws.com/graphql",
    "region": "us-east-1",
    "authenticationType": "API_KEY",
    "apiKey": "da1-5FkSFA1YR0u64dd1JcBuhQ"
}



// WEBPACK FOOTER //
// ./src/global/config/index.js